import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { editTimecard } from 'features/timesheets/TimesheetsPage/TimecardModal/slices';

import Issue from './Issue';

const MissingClockOut = ({ issue, onChangeShift, shift, setChangesMade }) => {
  const dispatch = useDispatch();
  const handleClick = useCallback(() => {
    dispatch(editTimecard());
    setChangesMade(true);

    if (shift.get('scheduled')) {
      onChangeShift('actual_end_at', shift.get('scheduled_end_at'));
    }
  }, [dispatch, onChangeShift, setChangesMade, shift]);

  return <Issue issue={issue} onClick={handleClick} />;
};

export default MissingClockOut;
